import { useCallback, useState } from 'react'

const buildInitialState = defaultTitle => ({
	visible: false,
	title: defaultTitle,
	prompt: '',
	model: '',
	temperature: 0,
	maxOutputTokens: 0,
})

/**
 * Local state for AI prompt preview modals (Ant Design v4 `visible`).
 */
export const usePromptPreview = (defaultTitle = 'AI Prompt Preview') => {
	const [preview, setPreview] = useState(() => buildInitialState(defaultTitle))

	const openPreview = useCallback(updates => {
		setPreview(prev => ({
			...prev,
			visible: true,
			...updates,
		}))
	}, [])

	const closePreview = useCallback(() => {
		setPreview(prev => ({ ...prev, visible: false }))
	}, [])

	const resetPreview = useCallback(() => {
		setPreview(buildInitialState(defaultTitle))
	}, [defaultTitle])

	return { preview, openPreview, closePreview, resetPreview }
}
